export default {
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },

  teams(state, teams) {
    return (state.teams = teams);
  },

  branches(state, branches) {
    return (state.branches = branches);
  },
  stationTeams(state, value) {
    return (state.stationTeams = value);
  },
  totalEmployees(state, total) {
    return (state.totalEmployees = total);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  filterValue(state, value) {
    return (state.filterValue = value);
  },
  editTeamData(state, value) {
    return (state.editTeamData = value);
  },
  employees(state, employees) {
    return (state.employees = employees);
  },
  totalTeams(state, value) {
    return (state.totalTeams = value);
  },
};
